@if (paymentPlan) {
    <account-page title="Payment Plan #{{ paymentPlan.service_id }}">
        <card-component>
            <card-content>
                <cdk-table-component
                    [displayColumns]="displayColumns"
                    [entities]="tableEntities"
                    [dataSource]="dataSource"
                    [footer]="footer"
                ></cdk-table-component>
                <raised-button [styles]="{ width: '100%' }" (click)="back()" color="primary">Back</raised-button>
            </card-content>
        </card-component>
    </account-page>
}
